module.exports = "<span class=\"invalid-feedback\" *ngIf=\"errorMessage != null\">{{errorMessage}}</span>\r\n"